var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tagName,
    _vm._b(
      {
        tag: "component",
        class: _vm.classes,
        on: { click: _vm.handleClickLink }
      },
      "component",
      _vm.tagProps,
      false
    ),
    [
      _vm.showHead
        ? _c(
            "div",
            { class: _vm.headClasses },
            [
              _vm._t("title", function() {
                return [
                  _vm.title
                    ? _c(
                        "p",
                        [
                          _vm.icon
                            ? _c("Icon", { attrs: { type: _vm.icon } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.title))])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExtra
        ? _c("div", { class: _vm.extraClasses }, [_vm._t("extra")], 2)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.bodyClasses, style: _vm.bodyStyles },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c0fdb05", { render: render, staticRenderFns: staticRenderFns })
  }
}